/*============================================================================
  COMPONENT — VIDEO sound toggle
  Wires every .video-frame on the page: click video or .video-sound to
  toggle mute. Button is revealed here (hidden by default = progressive
  enhancement). Poster-only frames (img, no .muted) are skipped.
==============================================================================*/

(function () {
  var frames = document.querySelectorAll('.video-frame');

  frames.forEach(function (frame) {
    var media = frame.querySelector('.video-media');
    var btn   = frame.querySelector('.video-sound');
    if (!media || typeof media.muted === 'undefined') return;

    var sync = function () {
      frame.dataset.muted = media.muted ? '1' : '0';
      if (btn) btn.setAttribute('aria-pressed', media.muted ? 'false' : 'true');
    };

    var toggle = function () {
      media.muted = !media.muted;
      if (!media.muted) media.play();
      sync();
    };

    media.addEventListener('click', toggle);
    if (btn) {
      btn.hidden = false;
      btn.addEventListener('click', toggle);
    }
    sync();
  });
})();
